import { D, roundFinal } from './money';
import { selectedPositions, tradingTax } from './totals';
import { jurisdiction } from '../../config/taxPlannerJurisdiction';

const sumTypes = (byType) => Object.values(byType).reduce((acc, v) => acc.plus(v), D(0));

// Cumulative per-lot tax impact. Each step is a difference of per-tax-type rounded
// trading taxes (the same rule as computeTotals), so the sum telescopes exactly.
export const computeImpact = (snapshot, selection, loss) => {
  const { rounding } = jurisdiction;
  const trading = snapshot.realized.buckets.find((b) => b.bucket === 'TRADING');
  let result = D(trading.income).minus(D(loss || 0));
  let taxBefore = sumTypes(tradingTax(snapshot, result));
  let total = D(0);

  const positions = selectedPositions(snapshot, selection).map(({ pos, key, sel }) => {
    let posImpact = D(0);
    const lots = sel.lots.map(({ fifoOrder }, i) => {
      result = result.plus(sel.lotResultsUah[i]);
      const taxAfter = sumTypes(tradingTax(snapshot, result));
      const impact = taxAfter.minus(taxBefore);
      taxBefore = taxAfter;
      posImpact = posImpact.plus(impact);
      return { fifoOrder, impact: roundFinal(impact, rounding).toFixed() };
    });
    total = total.plus(posImpact);
    return { key, impact: roundFinal(posImpact, rounding).toFixed(), lots };
  });

  return { positions, total: roundFinal(total, rounding).toFixed() };
};
